import React, { useEffect } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { useNavigate, useLocation, Routes, Route } from "react-router-dom";
import { CategoryList, CategoryEdit } from "../categories/categories";
import { ItemList, ItemEdit } from "../items/items"; // Assuming you have these components
import { ResourceContextProvider } from 'react-admin';

export const Catalog = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine the current tab based on the URL
  const currentTab = location.pathname.includes("/items") ? 1 : 0;

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) {
      navigate("/catalog/categories");
    } else if (newValue === 1) {
      navigate("/catalog/items");
    }
  };
  
  // Redirect to /catalog/categories by default
  useEffect(() => {
    if (location.pathname === "/catalog") {
      navigate("/catalog/categories", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={currentTab} onChange={handleTabChange} aria-label="Catalog Tabs">
          <Tab label="Categories" />
          <Tab label="Items" />
        </Tabs>
      </Box>
      <Box sx={{ p: 3 }}>
        <Routes>
          {/* Routes for Categories */}
          {currentTab === 0 && (
            <>
              <Route path="categories" element={
                <ResourceContextProvider value="category">
                  <CategoryList />
                </ResourceContextProvider>
              } />
              <Route path="categories/:id" element={
                <ResourceContextProvider value="category">
                  <CategoryEdit />
                </ResourceContextProvider>
              } />
            </>
          )}

          {/* Routes for Items */}
          {currentTab === 1 && (
            <>
              <Route path="items" element={
                <ResourceContextProvider value="item">
                  <ItemList />
                </ResourceContextProvider>
              } />
              <Route path="items/:id" element={
                <ResourceContextProvider value="item">
                  <ItemEdit />
                </ResourceContextProvider>
              } />
            </>
          )}
        </Routes>
      </Box>
    </Box>
  );
};

export default Catalog;